import { takeLatest, put } from 'redux-saga/effects';
import { call, select } from 'typed-redux-saga';
import * as api from 'data/api';
import { ExtraServiceCheckoutModal } from 'constants/extra-service';
import { logInPushUpScope } from 'components/Bumps';
import { getCookie, saveCookie } from 'libs/utils/cookies';
import { createSagaErrorBoundary } from 'libs/utils/sagaErrorBoundary';
import { actions } from './slice';
import * as selectors from './selectors';
import * as statelessActions from './actions';
import { VALUE_PROPOSITION_SHOWN_COOKIE_NAME } from './constants';
import { transformPushUpMinimumPrice, transformPushUpOrder, transformPushUpsOptions } from './transformers';
const callWithErrorLogging = createSagaErrorBoundary(logInPushUpScope);
export function* getPushUpOptions() {
  const itemIds = yield* select(selectors.getSelectedIds);

  if (!itemIds.length) {
    return;
  }

  const response = yield* call(api.getPushUpOptions, {
    itemIds
  });

  if ('errors' in response) {
    yield put(actions.getPushUpOptionsFailure());
    return;
  }

  const pushUpOptions = transformPushUpsOptions(response);
  yield put(actions.getPushUpOptionsSuccess({
    pushUpOptions
  }));
}
export function* getPushUpMinimumPrice(_ref) {
  let {
    payload: {
      itemPrice
    }
  } = _ref;
  const response = yield* call(api.getPushUpMinimumPrice, {
    itemPrice
  });

  if ('errors' in response) {
    yield put(statelessActions.getPushUpMinimumPriceFailure());
    return;
  }

  const pushUpMinimumPriceDto = response.minimum_price;
  const pushUpMinimumPrice = transformPushUpMinimumPrice(pushUpMinimumPriceDto);
  yield put(actions.getPushUpMinimumPriceSuccess({
    pushUpMinimumPrice
  }));
}
export function* preparePushUpOrder() {
  yield put(actions.preparePushUpOrderRequest());
  const itemIds = yield* select(selectors.getSelectedIds);
  const pushUpOption = yield* select(selectors.getSelectedPushUpOption);

  if (!pushUpOption) {
    return;
  }

  const response = yield* call(api.preparePushUpOrder, itemIds, pushUpOption.days, pushUpOption.international);

  if ('errors' in response) {
    yield put(actions.preparePushUpOrderFailure());
    return;
  }

  const pushUpOrder = response.push_up_order;
  yield put(actions.preparePushUpOrderSuccess({
    pushUpOrder: transformPushUpOrder(pushUpOrder)
  }));
}
export function* getPushUpOrder(_ref2) {
  let {
    payload: {
      pushUpOrderId
    }
  } = _ref2;
  const response = yield* call(api.getPushUpOrder, pushUpOrderId);

  if ('errors' in response) {
    yield put(actions.getPushUpOrderFailure());
    return;
  }

  const pushUpOrder = transformPushUpOrder(response.push_up_order);
  yield put(actions.getPushUpOrderSuccess({
    pushUpOrder
  }));
}
export function* startCheckout(_ref3) {
  let {
    payload: {
      selectedItemId
    }
  } = _ref3;

  if (selectedItemId) {
    yield put(actions.setSelectedItems({
      itemIds: [selectedItemId]
    }));
  }

  const isValuePropositionSeen = getCookie(VALUE_PROPOSITION_SHOWN_COOKIE_NAME);
  const showValueProposition = !isValuePropositionSeen || isValuePropositionSeen === 'false';

  if (showValueProposition) {
    saveCookie(VALUE_PROPOSITION_SHOWN_COOKIE_NAME, 'true');
    yield put(actions.setCheckoutModal({
      modal: ExtraServiceCheckoutModal.ValueProposition
    }));
    return;
  }

  yield put(actions.setCheckoutModal({
    modal: ExtraServiceCheckoutModal.OrderReview
  }));
}
export default function* saga() {
  yield takeLatest(statelessActions.startCheckout.type, startCheckout);
  yield takeLatest(statelessActions.startCheckoutReview.type, callWithErrorLogging(preparePushUpOrder));
  yield takeLatest([statelessActions.getPushUpOptionsRequest.type, actions.setSelectedItems], callWithErrorLogging(getPushUpOptions));
  yield takeLatest(actions.getPushUpOrderRequest.type, getPushUpOrder);
  yield takeLatest(statelessActions.getPushUpMinimumPriceRequest.type, getPushUpMinimumPrice);
}